// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".template-like.active .jump{animation-name:bounce-7;animation-duration:2s;animation-timing-function:cubic-bezier(0.28, 0.84, 0.42, 1)}@keyframes bounce-7{0%{transform:scale(1, 1) translateY(0)}10%{transform:scale(1.1, 0.9) translateY(0)}30%{transform:scale(0.9, 1.1) translateY(-30%)}50%{transform:scale(1.05, 0.95) translateY(0)}57%{transform:scale(1, 1) translateY(-2px)}64%{transform:scale(1, 1) translateY(0)}100%{transform:scale(1, 1) translateY(0)}}\n", ""]);
// Exports
module.exports = exports;
